import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useQueries } from 'react-query';
import { CACHE_FOREVER, productTypeParam } from './priceQueries.utils';
import { useIsTldPriceCacheEnabled } from './useIsTldPriceCacheEnabled';
import { useSuggestedTldPrices } from './useSuggestedTldPrices';
export const useTldPrices = (tlds, productType) => {
  var _perTld$find;
  const _DomainsApiClient$use = DomainsApiClient.useQueries(),
    listTldDisplayPrices = _DomainsApiClient$use.listTldDisplayPrices;
  const isTldPriceCacheOn = useIsTldPriceCacheEnabled();
  const uniqueTlds = isTldPriceCacheOn ? [...new Set(tlds)] : [];
  const _useSuggestedTldPrice = useSuggestedTldPrices(productType, uniqueTlds.length > 0),
    pool = _useSuggestedTldPrice.data,
    isPoolLoading = _useSuggestedTldPrice.isLoading;
  const poolPrice = tld => {
    var _pool$displayPrices;
    return pool == null || (_pool$displayPrices = pool.displayPrices) == null ? void 0 : _pool$displayPrices.find(entry => entry.tld === tld);
  };
  const tldsMissingFromPool = isPoolLoading ? [] : uniqueTlds.filter(tld => !poolPrice(tld));
  const perTld = useQueries(tldsMissingFromPool.map(tld => ({
    ...CACHE_FOREVER,
    queryKey: ['tldDisplayPrice', tld, productType],
    queryFn: () => listTldDisplayPrices({
      tlds: [tld],
      ...productTypeParam(productType)
    })
  })));
  const pricesByTld = new Map();
  uniqueTlds.forEach(tld => {
    var _poolPrice;
    const pricing = (_poolPrice = poolPrice(tld)) == null ? void 0 : _poolPrice.pricing;
    if (pricing) {
      pricesByTld.set(tld, pricing);
    }
  });
  perTld.forEach((_ref, index) => {
    var _data$displayPrices;
    let data = _ref.data;
    const pricing = data == null || (_data$displayPrices = data.displayPrices) == null || (_data$displayPrices = _data$displayPrices[0]) == null ? void 0 : _data$displayPrices.pricing;
    if (pricing) {
      pricesByTld.set(tldsMissingFromPool[index], pricing);
    }
  });
  return {
    pricesByTld,
    isLoading: uniqueTlds.length > 0 && isPoolLoading || perTld.some(_ref2 => {
      let isLoading = _ref2.isLoading;
      return isLoading;
    }),
    pricesExcludeTax: (pool == null ? void 0 : pool.pricesExcludeTax) ?? ((_perTld$find = perTld.find(_ref3 => {
      let data = _ref3.data;
      return data;
    })) == null || (_perTld$find = _perTld$find.data) == null ? void 0 : _perTld$find.pricesExcludeTax)
  };
};
//# sourceMappingURL=useTldPrices.js.map